import './contact_us.css';
import { useState } from 'react';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import axios from 'axios';
import { constants } from '../../constants';
function ContactUs() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [nameError, setNameError] = useState('');
  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    console.log('function working');
    //prevents the form from -
    //reloading the page
    //resetting the states
    //sending the data to the server
    e.preventDefault();

    let isValid = true;
    if (isSubmitting) return;
    // Clear previous errors first
    setEmailError('');
    setNameError('');
    setSubjectError('');
    setMessageError('');

    const emailAddRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // email error logic
    if (!emailAddRegex.test(email)) {
      setEmailError('Please enter a valid email address.');
      isValid = false;
    }
    if (name.trim() === '') {
      setNameError('Name cannot be empty');
      isValid = false;
    }
    if (subject.trim() === '') {
      setSubjectError('Subject cannot be empty');
      isValid = false;
    }
    if (message.trim() === '') {
      setMessageError('Message cannot be empty');
      isValid = false;
    } else if (message.trim().length < 20) {
      setMessageError('Message must be at least 20 characters long.');
      isValid = false;
    }

    setError('');
    if (!isValid) return;

    const data = {
      name,
      subject,
      email,
      message,
    };

    try {
      setIsSubmitting(true);
      const response = await axios.post(`${constants.baseUrl}/api/forms/contact-us`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data.message === 'Form submission received') {
        // window.location.reload();
        setToastType('success');
        setToastMessage('Your query has been successfully noted!');
        setTimeout(() => window.location.reload(), 4000);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setToastType('error');
      setToastMessage(err.response?.data?.message || 'Submission failed. Try again.');
      setIsSubmitting(false);
    }
  };
  return (
    <div>
      {toastMessage && <div className={`custom-toast ${toastType}`}>{toastMessage}</div>}
      <Navbar></Navbar>
      <div id="first-section">
        <div id="section -start">
          <div>
            <p id="first-section-title">
              <b>
                Get in Touch<br></br> with Us
              </b>
            </p>
          </div>
          <div>
            <p id="first-section-content">
              The IYNS Research Foundation welcomes collaboration and engagement from nuclear energy
              enthusiasts, students, researchers, professionals, and institutions. If you're looking
              to join as a member, explore our events and internship programs, or simply wish to
              learn more about nuclear technology, here's how you can connect with us:
            </p>
          </div>
        </div>

        <div className="row" id="form-section">
          <div className="form-content-section">
            <h2 className="support-nuclear">Support Nuclear</h2>
            <p className="support-nuclear-text">
              <b>Say yes to nuclear energy</b>: the powerful, scalable clean solution lighting the
              path to Net Zero - where innovation, safety, and sustainability unite to fuel a carbon
              free future for all.
            </p>

            {/* Phone */}
            <div className="row" id="address-row">
              <div className="emoji-col">📞</div>
              <div className="col">
                <div>Phone Number</div>
                <div
                  style={{
                    color: '#4C4C4C',
                    fontWeight: 500,
                    fontSize: '22px',
                  }}
                >
                  +91 817 878 8271
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="row" id="email-row">
              <div className="emoji-col">✉️</div>
              <div className="col">
                <div>Email</div>
                <div
                  style={{
                    color: '#4C4C4C',
                    fontWeight: 500,
                    fontSize: '22px',
                  }}
                >
                  contact@iyns.in
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="row" id="address-row">
              <div className="emoji-col">📍</div>
              <div className="col">
                <div>Address</div>
                <div
                  style={{
                    color: '#4C4C4C',
                    fontWeight: 500,
                    fontSize: '22px',
                  }}
                >
                  Ratan Apartment, Gururaj 1st Society Rd, Gururaj Society, Kothrud, Pune,
                  Maharashtra 411038
                </div>
              </div>
            </div>
          </div>

          {/* Form */}

          <div className="col" id="form">
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div>
              <div className="row">
                <div className="col">
                  <label>Name</label>
                  <input
                    type="text"
                    value={name}
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    placeholder="Enter your name"
                    onChange={(e) => setName(e.target.value)}
                  />
                  {nameError && <p style={{ color: 'red' }}>{nameError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>Subject</label>
                  <input
                    value={subject}
                    type="text"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    placeholder="Subject of message"
                    onChange={(e) => setSubject(e.target.value)}
                  />
                  {subjectError && <p style={{ color: 'red' }}>{subjectError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>Email</label>
                  <input
                    value={email}
                    type="email"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    placeholder="example@gmail.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>Message</label>
                  <textarea
                    value={message}
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    // rows="5"
                    placeholder="Type your message"
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                  {messageError && <p style={{ color: 'red' }}>{messageError}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    style={{
                      backgroundColor: isSubmitting ? '#aaa' : 'rgba(90, 45, 124, 1)',
                      color: 'white',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      borderRadius: '8px',
                      padding: '10px 16px',
                      border: 'none',
                      marginTop: '12px',
                      width: '12.5rem',
                      height: '2.8125rem',
                    }}
                    onClick={handleSubmit}
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="map-parent">
        <a
          href="https://share.google/smohikNHsqDcv0CBc"
          target="_blank"
          rel="noopener noreferrer"
          // style={{ display: 'inline-block' }}
        >
          <div id="map"></div>
        </a>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default ContactUs;
